// src/hooks/transportations/useForceDeleteAllTransportations.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllTransportations } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useForceDeleteAllTransportations = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllTransportationsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteAllTransportations,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete transportations");
        },
    });

    return {
        forceDeleteAllTransportations: forceDeleteAllTransportationsMutate,
        isForceDeleteAll: isPending || isLoading,
    };
};

export default useForceDeleteAllTransportations;
